import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  styled,
} from '@mui/material'
import PropTypes from 'prop-types';

const DialogStyled = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    padding: theme.spacing(1),
  },
}));

const ConfirmDialog = ({
  dialogTitle,
  contentText,
  confirmText,
  cancelText,
  onCancel,
  onConfirm,
  confirmStartIcon,
  open,
  ...dialogProps
}) => {
  if (!Array.isArray(contentText)) {
    contentText = [contentText]
  }

  return (
    <DialogStyled open={open} {...dialogProps}>
      <DialogTitle id='alert-dialog-title'>{dialogTitle}</DialogTitle>
      <DialogContent>
        {contentText.map((text, id) => (
          <DialogContentText key={id}>{text}</DialogContentText>
        ))}
      </DialogContent>
      <DialogActions>
        {cancelText && <Button onClick={onCancel}>{cancelText}</Button>}
        <Button variant={'outlined'} onClick={onConfirm} startIcon={confirmStartIcon} autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </DialogStyled>
  )
}

ConfirmDialog.propTypes = {
  dialogTitle: PropTypes.string.isRequired,
  contentText: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.arrayOf(PropTypes.string).isRequired]),
  confirmText: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  confirmStartIcon: PropTypes.element
}

export default ConfirmDialog
